import { cn } from "@lib/cn";
import type { CSSProperties } from "react";

interface IProps {
  noAnim?: boolean;
  style?: CSSProperties;
}

export const ImageSkeleton = ({ noAnim, style }: IProps) => {
  return (
    <div
      className={cn(
        "tw-h-full tw-w-full tw-rounded tw-bg-blue-50",
        !noAnim && "tw-animate-skeleton-loading",
      )}
      style={style}
    />
  );
};
